<template>
  <div class="home_wrap">
    <van-row class="topSection">
      <van-col span="4" style="text-align: left">
        <img
          src="../images/common/backArrow.png"
          @click="$router.back()"
          class="imageback"
        />
      </van-col>
      <van-col span="20" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700"
          >{{ $t("setmail.setNewEmail") }}</span
        >
      </van-col>
    </van-row>
    <van-row>
      <div class="wrap">
        <!-- ---------- email ------ -->
        <van-row style="margin-top: 15px">
          <van-col span="24"><p class="labelText">{{ $t("setmail.newEmail") }}</p></van-col>
        </van-row>
        <div class="item">
          <span class="icon">
            <img src="../images/register/email.png" alt="" />
          </span>
          <input type="text" class="inp" v-model="email" />
        </div>

        <!-- ----------- sms code ----------- -->
        <div>
          <van-row style="margin-top: 15px">
            <van-col span="24"
              ><p class="labelText">{{ $t("setmail.emailVerificationCode") }}</p></van-col
            >
          </van-row>
          <div class="item">
            <span class="icon"
              ><img src="../images/register/OTP.png" alt=""
            /></span>
            <input type="text" class="inp" v-model="code" />
            <van-count-down
              :time="time"
              class="btn get_code"
              @finish="timeCall"
            >
              <template v-slot="timeData">
                <span @click="sendcode">{{
                  timeData.seconds > 0
                    ? timeData.seconds
                    : $t("register.sendCode")
                }}</span>
              </template>
            </van-count-down>
          </div>
        </div>

        <van-row>
          <van-col span="24">
            <div
              class="confirm_btn"
              :class="email != '' && code != '' ? '' : 'no_touch'"
              @click="setEmail()"
            >
              {{ $t("setpwd.modify") }}
            </div>
          </van-col>
        </van-row>
      </div>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import { CountDown, Row, Col } from "vant";
import Fetch from "../../utils/fetch";

Vue.use(CountDown).use(Row).use(Col);

export default {
  name: "setemail",
  data() {
    return {
      email: "",
      code: "",
      time: 0,
      is_send: false,
    };
  },
  mounted() {},
  methods: {
    timeCall() {
      this.is_send = false;
      this.time = 0;
    },
    sendcode() {
      if (this.is_send) {
        return;
      }

      if (!this.email) {
        this.$toast(this.$t("setmail.emailEmpty"));
        return;
      }

      this.is_send = true;
      this.code = "";

      Fetch("/user/change_email_code", {
        email: this.email,
      })
        .then(() => {
          this.time = 60 * 1000;
          this.$toast({
            background: "#07c160",
            message: this.$t("setmail.emailVerficationSuccess"),
          });
        })
        .catch(() => {
          this.is_send = false;
        });
    },
    setEmail() {
      Fetch("/user/changeemail", {
        email: this.email,
        captcha: this.code,
      }).then((res) => {
        if (res.code) this.$toast.success();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 30px;
  width: auto;
}

.no_touch {
  pointer-events: none;
}

.wrap {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 25px 15px;
  background: #ebebeb29;
  margin: 10px;
}

.title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 18px;
    color: #000;
    font-weight: 400;
  }

  .cut {
    color: #ffffff;
    font-size: 14px;
    border: 1px solid #ffffff;
    padding: 4px;
    border-radius: 5px;
    width: fit-content;
    text-align: center;
    background-color: #247575;
  }
}

.bd_tel {
  margin-top: 23px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
}

.eye_bi {
  width: 21px;
  height: 25px;
  background: url(../images/user/eye2.png) no-repeat center center;
  background-size: 100% auto;
  margin-right: 10px !important;

  &.eye {
    background: url(../images/user/eye1.png) no-repeat center center;
    background-size: 100% auto;
  }
}

.confirm_btn.no_touch {
  color: rgba(255, 255, 255, 0.5);
}

.confirm_btn {
  height: 50px;
  line-height: 46px;
  font-size: 24px;
  width: 100%;
  border-radius: 15px;
  color: #ffffff;
  text-align: center;
  border: 1px solid #ffffff;
  margin-top: 60px;
  background: linear-gradient(
    117deg,
    rgba(254, 166, 0, 1) 0%,
    rgba(255, 188, 0, 1) 100%
  );
}

.labelText {
  color: #ffffff;
  padding: 4px 10px;
  font-size: 14px;
}

.item {
  height: 46px;
  border: 1px solid #ffffff;
  font-size: 14px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-bottom: 9px;
  border-radius: 20px;
  background: #d4dddfde;
  .icon {
    width: 70px;
    height: 27px;
    padding-left: 10px;
    display: flex;
    align-items: center;
    img {
      width: 27px;
      height: 27px;
    }
  }
  input {
    height: 20px;
    margin-left: 7px;
    flex: 1;
    margin-bottom: 3px;
  }
}

.get_code {
  height: 38px;
  line-height: 48px;
  font-size: 12px;
  color: #247575;
  margin-right: 10px;
  font-weight: 700;
}
</style>
